export const INDUSTRY_PRESETS = {
  general: { label: "General Retail", fields: [] },
  pharmacy: { label: "Pharmacy / Medical", fields: ["Doctor Name", "Patient Name", "Batch No."] },
  electronics: { label: "Electronics", fields: ["Serial No.", "Warranty"] },
  tender: { label: "Govt. Supply / Tender", fields: ["Tender No.", "Work Order No.", "Site Address"] },
  automobile: { label: "Automobile / Service", fields: ["Vehicle Model", "Chassis No.", "KM Reading"] },
  transport: { label: "Transport / Logistics", fields: ["LR No.", "Transporter", "Dispatch From"] },
  garments: { label: "Garments / Textile", fields: ["Size", "Colour", "Salesman"] },
};

export const SHOW_FIELDS = [
  ["po_no", "PO No."], ["eway_no", "E-Way Bill No."], ["vehicle_no", "Vehicle No."], ["due_date", "Due Date & Payment Terms"],
  ["hl_note", "Highlighted Note"], ["charges", "Additional Charges"], ["discounts", "Discounts"], ["tp", "TP / Tender Price"],
  ["extras", "Extra Fields"], ["terms", "Terms & Conditions"], ["bank_block", "Bank / QR / Signature"],
];

export const DEFAULT_QS = {
  prefix: "TI-", padding: 4, next_number: 1, quote_prefix: "TQ-", quote_padding: 4, quote_next: 1, industry: "general", auto_round_off: true, default_due_days: 0,
  show: Object.fromEntries(SHOW_FIELDS.map(([k]) => [k, true])),
  custom_fields: [],
  party: { phone: true, address: true, gstin: true, ship_to: true },
  items: { hsn: false, discount: true, tax: true },
  bank: { bank_name: "", holder: "", account_no: "", ifsc: "", upi_id: "", signature: "" },
};

export function mergeQs(data = {}) {
  return {
    ...DEFAULT_QS, ...data,
    show: { ...DEFAULT_QS.show, ...(data.show || {}) },
    party: { ...DEFAULT_QS.party, ...(data.party || {}) },
    items: { ...DEFAULT_QS.items, ...(data.items || {}) },
    bank: { ...DEFAULT_QS.bank, ...(data.bank || {}) },
    custom_fields: data.custom_fields || [],
  };
}
